// T134 Artefact 1 — one-call route meta composer. Most public routes only need
// this: title + description + canonical + hreflang + Open Graph/Twitter, derived
// from the route key + locale. The individual helpers stay exported for routes
// that need finer control.
import type { MetaDescriptor } from "react-router";
import type { Lang, RouteKey } from "~/config/route-config";
import { buildCanonical } from "./canonical";
import { buildHreflang } from "./hreflang";
import { buildOpenGraph, type OgType } from "./openGraph";

export interface RouteMetaInput {
  routeKey: RouteKey;
  locale: Lang;
  title: string;
  description: string;
  params?: Record<string, string>;
  ogType?: OgType;
  /** `undefined` → static default; `null` → omit; string → verbatim. */
  image?: string | null;
  /** e.g. `"noindex"` — adds `<meta name="robots">`. */
  robots?: string;
}

export function buildRouteMeta(input: RouteMetaInput): MetaDescriptor[] {
  const { routeKey, locale, title, description, params, ogType, image, robots } = input;
  const tags: MetaDescriptor[] = [
    { title },
    { name: "description", content: description },
  ];
  if (robots) tags.push({ name: "robots", content: robots });
  tags.push(...buildCanonical(routeKey, params, locale));
  tags.push(...buildHreflang(routeKey, params));
  tags.push(
    ...buildOpenGraph({ title, description, locale, type: ogType, image, routeKey, params }),
  );
  return tags;
}
